import { render, staticRenderFns } from "./PhotoBook.vue?vue&type=template&id=5a97344b&"
import script from "./PhotoBook.vue?vue&type=script&lang=js&"
export * from "./PhotoBook.vue?vue&type=script&lang=js&"
import style0 from "./PhotoBook.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports